import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Toggle from 'react-toggle';
import _ from 'lodash';
import SetShippingAddressFormv2 from './SetShippingAddressFormv2';
import { fetchHiddenPageSuggestions, toggleHiddenPageSuggestion, fetchPages, bulkUpdateCmsPageVisibility } from '../../../actions/website/PageActions';
import { toggleWebsite } from '../../../actions/WeddingActions';
import { showModal, hideModal } from '../../../actions/ModalActions';
import { fetchRegistry, updateRegistryPublish } from '../../../actions/RegistryActions';

function Page({ id, type, title, hidden, onToggle }) {
  return (
    <li className="hideable-item">
      <div className="hide-page-info">
        <i className={`zolaicon zolaicon-${type.toLowerCase()}`} />
        <div className="title">
          {title}
        </div>
        {type === 'RSVP' && (
          <div className="subtitle text-small text-muted margin-left hidden-xs">You must add guests to Guest List to use online RSVP</div>
        )}
      </div>
      <div className="hide-page-toggle">
        <div className="with-tooltip no-tooltip-on-mobile" data-tooltip="Control if guests see this page. Set to &quot;Hidden&quot; if you don't want to use it or it's still a work in progress. Set to &quot;Visible&quot; if you're ready to share.">
          <Toggle
            checked={!hidden}
            onChange={() => onToggle(id, hidden)}
            icons={{
              checked: <span className="zolaicon zolaicon-checkmark checked" />,
              unchecked: <span className="zolaicon zolaicon-close unchecked" />
            }}
          />
        </div>
      </div>
      {type === 'RSVP' && (
        <div className="subtitle text-small text-muted visible-xs rsvp-text">You must add guests to Guest List to use online RSVP</div>
      )}
    </li>
  );
}

Page.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  type: PropTypes.string,
  title: PropTypes.string,
  hidden: PropTypes.bool,
  onToggle: PropTypes.func,
};

function PageList({ pages, orderedIds, onToggle }) {
  return (
    <ul className="hideable-pages-list">
      {orderedIds.map(pageId => (
        <Page
          key={pageId}
          id={pageId}
          type={pages[pageId].type}
          title={pages[pageId].menu_title}
          hidden={pages[pageId].hidden}
          onToggle={onToggle}
        />
      ))}
    </ul>
  );
}

PageList.propTypes = {
  pages: PropTypes.shape({}),
  orderedIds: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
  onToggle: PropTypes.func.isRequired,
};

function PagesVisibility({ pages, orderedIds, onPublishWebsite, onTogglePage, hideModalFn }) {
  const pageCount = Object.values(pages).length;
  return (
    <div>
      <div className="modal-header">
        {pageCount === 1 && (
          <div>
            <h1>We Hid This Empty Page for You</h1>
            <p className="instructions bottom-border text-muted">
              You can still make your website visible without this page and add it back anytime.
            </p>
          </div>
        )}
        {pageCount !== 1 && (
          <div>
            <h1>We Hid These Empty Pages for You</h1>
            <p className="instructions bottom-border text-muted">
              You can still make your website visible without these and add them back anytime.
            </p>
          </div>
          )}
      </div>
      <div className="modal-body">
        <div className="hideable-pages">
          <PageList
            pages={pages}
            orderedIds={orderedIds}
            onToggle={onTogglePage}
          />
        </div>
      </div>
      <div className="modal-footer">
        <div className="modal-actions hide-pages-actions">
          <button className="btn btn-secondary hide-btn-cancel" onClick={hideModalFn}>Cancel</button>
          <button className="btn btn-primary hide-btn-cta" onClick={onPublishWebsite}>Make Website Visible</button>
        </div>
      </div>
    </div>
  );
}

PagesVisibility.propTypes = {
  pages: PropTypes.shape({}),
  orderedIds: PropTypes.arrayOf(PropTypes.number),
  onPublishWebsite: PropTypes.func.isRequired,
  onTogglePage: PropTypes.func.isRequired,
  hideModalFn: PropTypes.func,
};

export function RegistryVisibilityV2({ showShippingAddressForm, onPublishRegistry, onSetShippingAddress, onSkip }) {
  return (
    <div id="registry-visibility" className={`registry-visibility ${!showShippingAddressForm ? 'has-shipping-address' : ''}`}>
      {showShippingAddressForm ? (
        <div>
          <div className="modal-header">
            <h1 className="align-left shipping-header">Please Add Your Shipping Address</h1>
            <p className="instructions text-muted align-left">
              Make sure your gifts are shipped to the right place before your registry is visible.
            </p>
          </div>
          <div className="modal-body">
            <div className="shipping-form-container">
              <SetShippingAddressFormv2
                onSuccess={onSetShippingAddress}
                submitButtonText="Continue"
                secondaryButtonText="Skip"
                secondaryButtonAction={onSkip}
                secondaryButtonClassName="skip-publish-registry"
              />
            </div>
          </div>
        </div>
      ) : (
        <div>
          <div className="modal-header">
            <h1 className="shipping-header align-left">Please Confirm Your Shipping Address</h1>
            <p className="instructions text-muted align-left">
              Make sure your gifts are shipped to the right place before your registry is visible.
            </p>
          </div>
          <div className="modal-body">
            <div className="shipping-form-container">
              <SetShippingAddressFormv2
                onSuccess={onPublishRegistry}
                submitButtonText="Continue"
                submitButtonAction={onPublishRegistry}
                secondaryButtonText="Skip"
                secondaryButtonAction={onSkip}
                secondaryButtonClassName="skip-publish-registry"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

RegistryVisibilityV2.propTypes = {
  showShippingAddressForm: PropTypes.bool,
  onPublishRegistry: PropTypes.func.isRequired,
  onSetShippingAddress: PropTypes.func,
  onSkip: PropTypes.func.isRequired,
};

class HidePagesModal extends Component {
  constructor(props) {
    super(props);

    this.shouldShowRegistrySection = this.shouldShowRegistrySection.bind(this);
    this.togglePage = this.togglePage.bind(this);
    this.publishWebsite = this.publishWebsite.bind(this);
    this.publishRegistry = this.publishRegistry.bind(this);
    this.setShippingAddressSuccess = this.setShippingAddressSuccess.bind(this);

    this.state = {
      showRegistrySection: true,
      registryPublished: false,
      pagesToHide: {},
      orderedIds: [],
      showButtonSuccess: false,
    };
  }

  componentWillMount() {
    const { registryIds, registry } = this.props;
    if (registryIds.length > 0) {
      this.setState({
        showShippingAddressForm: !registry.has_shipping_address,
        registryPublished: registry.is_public,
      });
    }
  }

  componentDidMount() {
    const { getHiddenPageSuggestions } = this.props;
    getHiddenPageSuggestions();
  }

  componentWillReceiveProps(nextProps) {
    const { registry, registryIds, onPublishWebsite } = this.props;
    const { pages } = nextProps;
    const { orderedIds } = this.state;
    if (orderedIds.length === 0) {
      const visiblePages = _.omitBy(pages.hideablePagesById, page => (
        page.hidden || (page.type === 'REGISTRY' && registry.is_public)
      ));
      const visibleIds = _.filter(pages.orderedHideablePageIds, id => _.has(visiblePages, id));
      if (visibleIds.length > 0) {
        this.setState({
          pagesToHide: _.mapValues(visiblePages, visiblePage => _.merge({}, visiblePage, { hidden: true })),
          orderedIds: _.filter(pages.orderedHideablePageIds, id => _.has(visiblePages, id))
        });
      } else if (registryIds.length === 0 || registry.is_public) {
        onPublishWebsite();
      }
    }
    if (orderedIds.length > 0 && !registry.is_public && nextProps.registry.is_public) { // eslint-disable-line
      const visiblePages = _.omitBy(pages.hideablePagesById, page => (
        page.hidden || (nextProps.registry.is_public && page.type === 'REGISTRY') // eslint-disable-line
      ));
      const visibleIds = _.filter(pages.orderedHideablePageIds, id => _.has(visiblePages, id));
      if (visibleIds.length > 0) {
        this.setState({
          pagesToHide: _.mapValues(visiblePages, visiblePage => _.merge({}, visiblePage, { hidden: true })),
          orderedIds: _.filter(pages.orderedHideablePageIds, id => _.has(visiblePages, id))
        });
      } else if (registryIds.length === 0 || nextProps.registry.is_public) { // eslint-disable-line
        onPublishWebsite();
      }
    }
  }

  componentWillUnmount() {
    const { getPages } = this.props;
    getPages();
  }

  setShippingAddressSuccess() {
    const { onPublishRegistry, onPublishWebsite } = this.props;
    const { orderedIds } = this.state;
    onPublishRegistry(true).then(() => {
      if (orderedIds.length === 0) {
        onPublishWebsite();
      } else {
        this.setState({ registryPublished: true });
      }
    });
  }

  publishRegistry() {
    const { onPublishRegistry, onPublishWebsite } = this.props;
    const { orderedIds } = this.state;
    onPublishRegistry(true).then(() => {
      this.setState({ showButtonSuccess: true });
      setTimeout(() => {
        if (orderedIds.length === 0) {
          onPublishWebsite();
        } else {
          this.setState({ registryPublished: true });
        }
      }, 1000);
    });
  }

  publishWebsite() {
    const { onBulkUpdatePageVisibility, onPublishWebsite } = this.props;
    const { pagesToHide } = this.state;
    const updateCmsPageHiddenRequest = _.map(pagesToHide, page => ({
      id: page.id,
      hidden: page.hidden
    }));
    onBulkUpdatePageVisibility(updateCmsPageHiddenRequest).then(onPublishWebsite);
  }

  togglePage(pageId) {
    this.setState((state) => {
      const { pagesToHide } = state;
      const page = _.merge({}, pagesToHide[pageId], { hidden: !pagesToHide[pageId].hidden });
      return {
        pagesToHide: _.merge({}, pagesToHide, { [pageId]: page })
      };
    });
  }

  shouldShowRegistrySection(showRegistrySection) {
    const { onPublishWebsite } = this.props;
    const { orderedIds } = this.state;
    this.setState({ showRegistrySection }, () => {
      if (orderedIds.length === 0) {
        onPublishWebsite();
      }
    });
  }

  render() {
    const { registry, hideModalFn } = this.props;
    const { showRegistrySection, showShippingAddressForm, orderedIds, pagesToHide, registryPublished, showButtonSuccess } = this.state;

    return (
      <div id="hide-pages-modalv2">
        {registry.status === 'ACTIVE' && !registryPublished && showRegistrySection ? (
          <div id="publish-resgistry-modal">
            <RegistryVisibilityV2
              registry={registry}
              onPublishRegistry={this.publishRegistry}
              onSetShippingAddress={this.setShippingAddressSuccess}
              onSkip={() => this.shouldShowRegistrySection(false)}
              showButtonSuccess={showButtonSuccess}
              showShippingAddressForm={showShippingAddressForm}
            />
          </div>
        ) : (
          <div id="hidden-pages">
            <PagesVisibility
              pages={pagesToHide}
              orderedIds={orderedIds}
              onPublishWebsite={this.publishWebsite}
              onTogglePage={this.togglePage}
              hideModalFn={hideModalFn}
            />
          </div>
        )}
      </div>
    );
  }
}

HidePagesModal.propTypes = {
  pages: PropTypes.shape({
    hideablePagesById: PropTypes.shape({}),
    orderedHideablePageIds: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
  }),
  registry: PropTypes.shape({}),
  registryIds: PropTypes.arrayOf(PropTypes.string),
  getHiddenPageSuggestions: PropTypes.func.isRequired,
  onPublishRegistry: PropTypes.func,
  onPublishWebsite: PropTypes.func.isRequired,
  hideModalFn: PropTypes.func,
  getPages: PropTypes.func,
  onBulkUpdatePageVisibility: PropTypes.func,
};

const mapStateToProps = state => ({
  pages: state.website.pages,
  registry: state.registry,
  registryIds: state.user.userContext.registry_ids,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  getHiddenPageSuggestions: () => dispatch(fetchHiddenPageSuggestions()),
  getPages: () => dispatch(fetchPages()),
  getRegistry: () => dispatch(fetchRegistry()),
  onPublishRegistry: isPublic => dispatch(updateRegistryPublish(isPublic)),
  onPublishWebsite: () => dispatch(toggleWebsite(true)).then(() => {
    if (ownProps.afterPublish) {
      return ownProps.afterPublish();
    }
    return dispatch(showModal('PUBLISH_WEBSITE', {}, { size: 'md' }));
  }),
  onTogglePage: (id, hidden) => dispatch(toggleHiddenPageSuggestion(id, !hidden)).then(() => dispatch(fetchHiddenPageSuggestions())),
  onBulkUpdatePageVisibility: updateCmsPageHiddenRequest => dispatch(bulkUpdateCmsPageVisibility(updateCmsPageHiddenRequest)),
  closeModal: () => dispatch(hideModal()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HidePagesModal);



/** WEBPACK FOOTER **
 ** ./src/components/manage/common/HidePagesModalv2.jsx
 **/